var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TreeItem, TreeView } from '@material-ui/lab';
import CreateRouteDialog from '../dialogs/CreateRouteDialog';
import { useSendEditPath } from '../hooks/iframe-messaging/useSendEditPath';
import { useSiteRouteComponents } from '../hooks/site-route/useSiteRouteComponents';
import { useSiteContext } from '../SiteContext';
import { Icon } from '@material-ui/core';
export const SiteRouteList = ({ addState }) => {
    const [openDialog, setOpenDialog] = addState;
    const { site, setEditPath, configureComponent, setSelectedComponent, getSiteComponents } = useSiteContext();
    const siteRouteComponents = useSiteRouteComponents();
    const { sendEditPath } = useSendEditPath();
    // load site routes on load and after component selection change
    // build a route component tree using all route components
    const routeTrees = useMemo(() => {
        const routeTrees = siteRouteComponents.reduce((result, component, index) => {
            const { name = 'Untitled' } = component;
            const { path } = component.props || {};
            if (index === 0) {
                result.push({ name, path, component, children: [] });
            }
            else {
                const previousRouteTree = result[result.length - 1];
                // console.log('path', path, result.length - 1, result);
                if ((component.depth || 0) > 0 &&
                    path &&
                    path.indexOf(`${previousRouteTree.path}/`) === 0) {
                    previousRouteTree.children.push({
                        name,
                        path,
                        component,
                        children: []
                    });
                }
                else {
                    result.push({ name, path, component, children: [] });
                }
            }
            return result;
        }, []);
        return routeTrees;
    }, [siteRouteComponents]);
    return (React.createElement(React.Fragment, null,
        React.createElement(TreeView, { defaultCollapseIcon: React.createElement(Icon, null, "arrow_drop_down"), defaultExpandIcon: React.createElement(Icon, null, "arrow_right"), selected: (configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.id) || '' }, routeTrees === null || routeTrees === void 0 ? void 0 : routeTrees.map(routeTree => (React.createElement(SiteRouteItem, { key: routeTree.component.id, routeTree: routeTree, onClick: routeTree => {
                var _a, _b;
                setEditPath(((_a = routeTree.component.props) === null || _a === void 0 ? void 0 : _a.path) || null);
                if ((_b = routeTree.component.props) === null || _b === void 0 ? void 0 : _b.path) {
                    sendEditPath(routeTree.component.props.path);
                }
                // console.log('routeTree.component', routeTree.component);
                setSelectedComponent(routeTree.component);
            } })))),
        openDialog && (React.createElement(CreateRouteDialog, { open: true, onCancel: () => setOpenDialog(false), onCreated: () => {
                (site === null || site === void 0 ? void 0 : site.id) && getSiteComponents(site.id);
                setOpenDialog(false);
            } }))));
};
export default SiteRouteList;
const SiteRouteItem = (_a) => {
    var _b;
    var { routeTree, onClick } = _a, props = __rest(_a, ["routeTree", "onClick"]);
    const { subscribe, unsubscribe } = useSiteContext();
    const [component, setComponent] = useState(routeTree.component);
    // Make a local reference to the component state
    const componentRef = useRef(component);
    // Subscribe to any component changes coming from the component editor
    useEffect(() => {
        const handleSubscribe = (component) => {
            componentRef.current = component;
            setComponent(component);
        };
        const component = componentRef.current;
        subscribe(component, handleSubscribe);
        return () => unsubscribe(component, handleSubscribe);
    }, [subscribe, unsubscribe]);
    return (React.createElement(TreeItem, Object.assign({ className: 'tree-item', nodeId: routeTree.component.id, label: component.name, onLabelClick: event => {
            event.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick(routeTree);
        } }, props), (_b = routeTree.children) === null || _b === void 0 ? void 0 : _b.map(routeTree => (React.createElement(SiteRouteItem, Object.assign({ key: routeTree.component.id, routeTree: routeTree, onClick: onClick }, props))))));
};
//# sourceMappingURL=SiteRouteList.js.map